import React, { Component } from "react";
import { connect } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "rc-tooltip";

class DocSaveIndicator extends Component {
  state = {
    text: "",
    icon: "",
    faIconType: "fal",
    tooltipText: "",
    className: "",
  };

  componentDidMount() {
    this._decideView(this.props.docSaveIndicator);
  }

  componentDidUpdate(prevProps) {
    if (this.props.docSaveIndicator !== prevProps.docSaveIndicator) {
      if (
        prevProps.docSaveIndicator === "SAVING" &&
        this.props.docSaveIndicator === "SAVED"
      ) {
        // This is to show the 'saving..' text for little longer
        setTimeout(() => {
          this._decideView(this.props.docSaveIndicator);
        }, 1000);
      } else {
        this._decideView(this.props.docSaveIndicator);
      }
    }
  }

  _decideView = value => {
    switch (value) {
      case "SAVED":
        this.setState({
          text: "Saved",
          icon: "check-circle",
          faIconType: "fal",
          tooltipText: "Recent changes saved",
          className: "doc-saved-indication",
        });
        break;
      case "SAVING":
        this.setState({
          text: "Saving...",
          icon: "spinner",
          faIconType: "fad",
          tooltipText: "Changes are getting saved",
          className: "",
        });
        break;
      // Currently not handling the api fail cases
      case "SAVE_FAILED":
        this.setState({
          text: "Unsaved changes",
          icon: "exclamation-circle",
          faIconType: "fal",
          tooltipText:
            "Changes were not saved and progress may be lost. Refresh page and continue editing.",
          className: "doc-save-failed",
        });
        break;
      default:
        this.setState({
          text: "Saved",
          icon: "check-circle",
          faIconType: "fal",
          tooltipText: "Recent changes saved",
          className: "",
        });
        break;
    }
  };

  render() {
    const { text, icon, faIconType, tooltipText, className } = this.state;
    if (this.props.docSaveIndicator === "HIDE") {
      return null;
    }
    return (
      <Tooltip
        placement="bottom"
        align={{
          offset: [0, -4],
        }}
        overlay={tooltipText}>
        <div
          className={`${
            this.props.template
              ? "template-save-indicator"
              : "doc-save-indicator"
          }`}>
          <FontAwesomeIcon
            className={`${className} ${text === "Saving..." && "fa-spin"}`}
            icon={[faIconType, icon]}
          />
          <span className={className}>{text}</span>
        </div>
      </Tooltip>
    );
  }
}

const mapStateToProps = state => {
  const {
    docSaveIndicator,
    document: { meta_data: metaData } = {},
  } = state.DocumentStore;
  return { docSaveIndicator, metaData };
};

export default connect(
  mapStateToProps,
  null,
)(DocSaveIndicator);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/DocSaveIndicator/index.js